/*
 * AVS hover-video (2026-08-11, kein Vendor-Code)
 *
 * Produktkarten-Hover-Video: Auf Geraeten mit echtem Hover (Maus) laedt das
 * Video erst beim ersten mouseenter (die <source>-Elemente kommen mit
 * data-src aus dem Liquid, damit vorher garantiert nichts geladen wird) und
 * spielt dann; mouseleave pausiert und spult zurueck. Auf Touch-Geraeten
 * passiert nichts — dort bleibt das Featured-Image, null Bytes Video.
 *
 * Das Element traegt die Klassen des Hover-Bilds (card__hover-image …),
 * dadurch greifen die vorhandene CSS-Hover-Logik (main.css) und die
 * is-inactive-Aktivierung aus main.js (loadHoverImage) unveraendert.
 * Gerendert von snippets/product-card.liquid, Daten aus dem Produkt-Metafield
 * custom.hover_video (gesetzt von shop-ops/video_publish.py --produkt).
 */

if (!customElements.get('hover-video')) {
  class HoverVideo extends HTMLElement {
    connectedCallback() {
      // min-width passend zur CSS-Hover-Regel (main.css): darunter gibt es
      // keinen sichtbaren Reveal, also auch nichts zu laden.
      if (!window.matchMedia('(min-width: 480px) and (hover: hover) and (pointer: fine)').matches) return;
      if (this.bound) return; // connectedCallback feuert bei DOM-Moves erneut
      this.bound = true;

      this.video = this.querySelector('video');
      if (!this.video) return;

      this.media = this.closest('.card__media') || this.parentElement;
      this.media.addEventListener('mouseenter', this.handleEnter.bind(this));
      this.media.addEventListener('mouseleave', this.handleLeave.bind(this));
    }

    handleEnter() {
      if (!this.activated) {
        this.activated = true;
        this.video.querySelectorAll('source[data-src]').forEach((source) => {
          source.src = source.dataset.src;
        });
        this.video.load();
      }

      const promise = this.video.play();
      if (promise) promise.catch(() => { /* Autoplay verweigert -> Poster bleibt */ });
    }

    handleLeave() {
      this.video.pause();
      this.video.currentTime = 0;
    }
  }

  customElements.define('hover-video', HoverVideo);
}
